import { Component, Input } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Quiz } from '../../DTO/Quiz';
import { QuizService } from '../../Service/Quizservice';
import { Router, UrlSerializer } from "@angular/router";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material/dialog';
import { PdfExportPage } from '../pages/pdfexport.page'
import { Publishpage } from '../pages/publish.page'
import { Genrateurlpage } from "../pages/Generateurl.page";
import { DeleteQuizpage } from "../pages/DeleteQuiz.page";
import { SurveyPage } from '../pages/survey.page'
import {PageEvent} from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';

import CryptoJS from 'crypto-js';

@Component({
    selector: "QuizGen-page",
    templateUrl: "./QuizGen.page.html",
    styleUrls: ["../app.component.css"],
})
export class QuizGenpage {
    // Debugger;
    // @Input() quiz1: Quiz;
    // dialogRef;
    // length = 10;
    // pageSize = 8;
    // pageindex=1;
     teachername;
     teacherid
    // pageSizeOptions: number[] = [8];
    // studentdata: any;
    quizid;
    json;
    classData;
    subjectData;
    chapterData;
    aiurl;
    selectedClass: string = 'Select'; // Initialize with 'Select'
selectedSubject: string = 'Select'; // Initialize with 'Select'
selectedChapter: string = 'Select';
selectedClassText: string = ''; // Variable to store selected class text
selectedSubjectText: string = ''; // Variable to store selected subject text
selectedChapterText: string = ''; // Variable to store selected chapter text
//selectedNumberOfQuestions: string = "5"; // Default number of questions
selectedNumberOfQuestions: number = 6;
//pattern: RegExp = /^(1?[5-9]|20)$/;
pattern: RegExp = /^(1[0-9]|20|6|7|8|9)$/;



inputIsValid: boolean = true; 
    constructor(private router: Router, private QuizService: QuizService,private _snackBar: MatSnackBar, private serializer: UrlSerializer, public dialog: MatDialog,private http: HttpClient) {
        // this.teachername = sessionStorage.getItem('teachername');
        // if (this.teachername == undefined) {
        //     this.logout();
        // }
        // else{
        //     this.teacherid=sessionStorage.getItem("Td");
        //     this.refreshdata()
        // }
        // document.getElementById("btnGroupDrop1").innerText = this.teachername;
        this.getconfigkey().subscribe(data=>{
          this.aiurl=data['aiurl']
          
      }
      );
    }

     public getconfigkey():any{            
            return this.http.get("assets/env.json");            
        }
    ngOnInit() {
      this.teachername = sessionStorage.getItem('teachername');
        if (this.teachername == undefined) {
            this.logout();
        }
        
        else{
            this.teacherid=sessionStorage.getItem("Td");
            document.getElementById("btnGroupDrop1").innerText = this.teachername;
           // this.refreshdata()
        }
        
      this.selectedClass = 'Select';
  this.selectedSubject = 'Select';
  this.selectedChapter = 'Select';

  this.QuizService.getClassData().subscribe(data => {
    this.classData = data;
  });
        // this.teachername = sessionStorage.getItem('teachername');
        // if (this.teachername == undefined) {
        //     this.logout();
        // }
        
        // else{
        //     this.teacherid=sessionStorage.getItem("Td");
        //  //   this.refreshdata()
        // }
        
        //document.getElementById("btnGroupDrop1").innerText = this.teachername;
    }

    onClassChange(event: any) {
      if (this.selectedClass !== 'Select') {
        this.selectedClassText = event.target.options[event.target.selectedIndex].text;
        this.subjectData = [];
        this.chapterData = [];
        this.selectedSubject = 'Select'
        this.selectedChapter = 'Select';
        // Fetch subject data based on the selected class and update subjectData
        this.QuizService.getSubjectsForClass(this.selectedClass).subscribe(data => {
          this.subjectData = data;
        });
        const errmsg = document.getElementById("drpdownerr");
          errmsg.style.display = "none";
      } else {
        // Reset subjectData if "Select" is chosen for class
        this.subjectData = [];
        this.chapterData = [];
      }
    }
    
    // Update the chapter dropdown based on the selected class and subject
    onSubjectChange(event: any) {
      if (this.selectedClass !== 'Select' && this.selectedSubject !== 'Select') {
        this.selectedSubjectText = event.target.options[event.target.selectedIndex].text;
        this.chapterData = [];
        this.selectedChapterText = "Select";
        // Fetch chapter data based on the selected class and subject and update chapterData
        this.QuizService.getChaptersForClassAndSubject(this.selectedClass, this.selectedSubject).subscribe(data => {
          this.chapterData = data;
        });
        const errmsg = document.getElementById("drpdownsubjecterr");
          errmsg.style.display = "none";
      } else {
        // Reset chapterData if either class or subject is set to "Select"
        this.chapterData = [];
      }
    }

    onChapterChange(event: any) {
      this.selectedChapterText = event.target.options[event.target.selectedIndex].text;
      const errmsg = document.getElementById("drpdownchaptererr");
          errmsg.style.display = "none";
    }
    

    aiqgenerate(selectedClass, selectedSubject, selectedChapter, selectedNumberOfQuestions) {
        // Encode the variables and add them as query parameters to the URL
        const loadingMessage = document.getElementById("loadingMessage");
        const overlay = document.getElementById("overlay");
        loadingMessage.style.display = "block";
        overlay.style.display = "block";
        const queryString = `?class=${encodeURIComponent(selectedClass)}&subject=${encodeURIComponent(selectedSubject)}&chapter=${encodeURIComponent(selectedChapter)}&noOfQuestions=${encodeURIComponent(selectedNumberOfQuestions)}`;
        //alert('queryString'+queryString);this.apiurl
        // Make a GET request to your Express server with the query parameters
       // fetch(`http://127.0.0.1:5000/generate-quiz${queryString}`) // Update the URL to match your route
       if(this.inputIsValid){
       fetch(this.aiurl+`generate-quiz${queryString}`)
          .then((response) => response.json())
          .then((data) => {
            // Handle the quiz data returned from the server
           // alert('Generated Quiz:'+ data);
            console.log(data);
            // let titleValue = this.findKeyValue(data, "Quiz Title");
            // $(".title_editable > span")[2].innerText = titleValue;
            // let descValue = this.findKeyValue(data, "Quiz Description");
            // $(".description_editable > span")[2].innerText =descValue;
            let jsonData;
            let jsonString;
            const jsonMatch = data.match(/\{[\s\S]*\}/);
            if (jsonMatch) {
              jsonString = jsonMatch[0];
              // Parse the JSON data
              jsonData = JSON.parse(jsonString);
              jsonData.teacherid=this.teacherid;
              jsonData.isAutoGenerated=1;

              const currentTimestamp = new Date().toISOString();

              // Modify the title property with the current timestamp
              if (jsonData.hasOwnProperty("title")) {
                jsonData.title += " - " + currentTimestamp; // You can adjust the format as needed
              }
              jsonString = JSON.stringify(jsonData);
              console.log(jsonString)
            }
            this.QuizService.addjsondata(jsonString)
            .subscribe(data => {
              loadingMessage.style.display = "none";
              overlay.style.display = "none";
              this.Navigateedit(JSON.parse(JSON.stringify(data))['status'])
            });
            // const jsonString = data.trim();
            // const surveyJson = JSON.parse(jsonString);//JSON.parse(data);
            // console.log(jsonData);
            //const survey = new Model(jsonData);
            //this.json = survey;
            // You can perform further actions with the quiz data here
          })
          .catch((error) => {
            //alert('Error:'+ error);
            alert('Please try again');
            console.error('Error:', error);
            loadingMessage.style.display = "none";
            overlay.style.display = "none";
            // Handle any errors that occur during the request
          });
        }
        else
        {
          alert('Please enter valid inputs');
          loadingMessage.style.display = "none";
          overlay.style.display = "none";
        }
      }
    
      findKeyValue(jsonObject: any, keyToFind: string): any | undefined {
        for (const key in jsonObject) {
          if (key === keyToFind) {
            return jsonObject[key];
          } else if (typeof jsonObject[key] === 'object') {
            const result = this.findKeyValue(jsonObject[key], keyToFind);
            if (result !== undefined) {
              return result;
            }
          }
        }
        return undefined;
      }
    
      validateInput() {
        this.inputIsValid = this.pattern.test(this.selectedNumberOfQuestions.toString());
        // if (!this.inputIsValid) {
        //   this.selectedNumberOfQuestions = 5; // Set a default value if the input doesn't match the pattern
        // }
      }
      
      
      
      onGenerateClick(selectedClass: string, selectedSubject: string, selectedChapter: string,selectedNumberOfQuestions:string) {
        if (selectedClass === 'Select'  || selectedSubject === 'Select'||  selectedChapter === 'Select'|| selectedClass==="" && selectedSubject==="" && selectedChapter==="" && this.inputIsValid) {
          // At least one dropdown is still at "Select," so do not call aiqgenerate()
         // alert('Please select valid options before generating.');
         const errmsg = document.getElementById("drpdownerr");
         errmsg.style.display = "block";
        } 
        else if(selectedClass==="")
        {
          const errmsg = document.getElementById("drpdownerr");
          errmsg.style.display = "block";
        }
        else if(selectedSubject==="")
        {
          const errmsg = document.getElementById("drpdownsubjecterr");
          errmsg.style.display = "block";
        }
        else if(selectedChapter===""){
          const errmsg = document.getElementById("drpdownchaptererr");
          errmsg.style.display = "block";
        }
        else if(!this.inputIsValid){
          const errmsg = document.getElementById("inputIsValid");
          errmsg.style.display = "block";
        }
        
        else {
          // All dropdowns have valid selections, so call aiqgenerate() with the selected values
          const errmsg = document.getElementById("drpdownerr");
          errmsg.style.display = "none";
          this.aiqgenerate(selectedClass, selectedSubject, selectedChapter, selectedNumberOfQuestions);
        }
      }


    //   isQuizExpired(endDate: string): boolean {
    //     const currentDate = new Date(); // Get current date
    //     const quizEndDate = new Date(endDate);
    //     if(quizEndDate<currentDate)
    //     {
    //         return quizEndDate < currentDate;
    //     }
    //      // Convert end date string to Date object
    //   }
    logout() {
        this.router.navigate(["/"]);
        sessionStorage.clear();
    }

    Navigateedit(obj) {
      if (obj == "S001") {
        var snackBarRef;
        if (this.quizid == undefined) {
          /*document.getElementById("svd-save").style.pointerEvents = "none";*/
          snackBarRef = this._snackBar.open("Quiz Generated Successfully", "OK", {
          });
        }
        else {
          snackBarRef = this._snackBar.open("Update Successful", "OK", {
            duration: 2000,
          });
        }
        this.json = {
          "pages": [{
            "name": "Page1", "title": "Quiz Name", "description": "Quiz Description"
          }]
        };
        snackBarRef.onAction().subscribe(() => {
          this.router.navigate(['/quizlist'])
        });
  
      }
      else
      {
        var snackBarRef;
        snackBarRef = this._snackBar.open("Quiz Generation UnSuccessful", "", {
          duration: 2000,
        });
      }
  
    }

}
